"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _Button = _interopRequireDefault(require("../Button"));

var _ChevronLeft = _interopRequireDefault(require("elevate-ui-icons/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("elevate-ui-icons/ChevronRight"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var Pagination =
/*#__PURE__*/
function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination(props) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this));
    _this.getSafePage = _this.getSafePage.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.changePage = _this.changePage.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.applyPage = _this.applyPage.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      page: props.page
    };
    return _this;
  }

  _createClass(Pagination, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        page: nextProps.page
      });
    }
  }, {
    key: "getSafePage",
    value: function getSafePage(page) {
      if (Number.isNaN(page)) {
        page = this.props.page;
      }

      return Math.min(Math.max(page, 0), this.props.pages - 1);
    }
  }, {
    key: "changePage",
    value: function changePage(page) {
      page = this.getSafePage(page);
      this.setState({
        page: page
      });

      if (this.props.page !== page) {
        this.props.onPageChange(page);
      }
    }
  }, {
    key: "applyPage",
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }

      var page = this.state.page;
      this.changePage(page === "" ? this.props.page : page);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          canPrevious = _this$props.canPrevious,
          canNext = _this$props.canNext,
          className = _this$props.className,
          classes = _this$props.classes,
          filterable = _this$props.filterable,
          onShowFilters = _this$props.onShowFilters,
          onHideFilters = _this$props.onHideFilters,
          page = _this$props.page,
          showFilters = _this$props.showFilters;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className),
        style: this.props.style
      }, filterable && _react.default.createElement(_Button.default, {
        innerClassName: classes.filterButton,
        color: "secondary",
        isOutlined: true,
        onClick: !showFilters ? onShowFilters : onHideFilters
      }, _react.default.createElement("span", null, !showFilters ? "Show" : "Hide", " Filters")), _react.default.createElement("div", {
        className: classes.buttons
      }, _react.default.createElement("button", {
        type: "button",
        title: "Previous Page",
        className: classes.button,
        onClick: function onClick() {
          if (!canPrevious) return;

          _this2.changePage(page - 1);
        },
        disabled: !canPrevious
      }, _react.default.createElement(_ChevronLeft.default, {
        width: 16,
        height: 16
      })), _react.default.createElement("button", {
        type: "button",
        title: "Next Page",
        className: classes.button,
        onClick: function onClick() {
          if (!canNext) return;

          _this2.changePage(page + 1);
        },
        disabled: !canNext
      }, _react.default.createElement(_ChevronRight.default, {
        width: 16,
        height: 16
      }))));
    }
  }]);

  return Pagination;
}(_react.Component);

var styles = function styles(theme) {
  return {
    root: {
      display: "flex",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      padding: "5px 8px",
      borderBottom: "1px solid ".concat(theme.colors.gray200)
    },
    filterButton: {
      padding: "4px 6px"
    },
    buttons: {
      marginLeft: "12px",
      "& > * + *": {
        marginLeft: "6px"
      }
    },
    button: {
      display: "inline-flex",
      color: theme.colors.gray600,
      padding: "6px",
      border: "1px solid ".concat(theme.colors.gray300),
      borderRadius: theme.globalBorderRadius,
      "&:disabled": {
        opacity: 0.25
      }
    }
  };
};

var _default = (0, _withStyles.default)(styles, {
  name: "EuiPagination"
})(Pagination);

exports.default = _default;